import { Link } from "react-router-dom";
import { type MediaItem, MEDIA_TYPE_LABEL } from "@/mocks/media";

interface MediaCardProps {
  item: MediaItem;
  showType?: boolean;
}

export default function MediaCard({ item, showType = true }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={item.image}
          alt={`${item.title} 海报`}
          title={`${item.title} - ${MEDIA_TYPE_LABEL[item.type]}推荐`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2 flex items-center gap-1 px-2 py-0.5 rounded-full bg-accent-500/90 text-background-50 text-xs font-semibold">
          <i className="ri-star-fill text-[10px]" />
          {item.rating.toFixed(1)}
        </div>
        {showType && (
          <div className="absolute bottom-2 left-2 px-2 py-0.5 rounded-full bg-foreground-950/70 text-background-50 text-xs font-medium">
            {MEDIA_TYPE_LABEL[item.type]}
          </div>
        )}
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {item.genres.join(" · ")} · {item.year}
        </p>
      </div>
    </Link>
  );
}